import { useTranslation } from 'react-i18next';

import { ISuppliers } from '@/modules/workforce/Crew/types';
import { Typography } from '@/shared/components/atoms';
import PartialListWithTooltip from '@/shared/components/molecules/PartialListWithTooltip';
import { Item } from '@/shared/components/molecules/PartialListWithTooltip/IPartialListWithTooltip';

import CallSvg from '~/images/shared/Call.svg';
import NoteSvg from '~/images/shared/note.svg';
import TreeSvg from '~/images/shared/tree.svg';
import WorkerSvg from '~/images/shared/Worker.svg';
interface InfoCardProps {
  phoneNumber: string;
  supplierId: number;
  numberOfWorkers: number;
  experience?: ISuppliers.IGetSupplierExperienceData[];
}
// TODO: refactor this!
// TODO: move interface
// TODO: refactor the crews files and delete unused
export default function InfoCard(props: InfoCardProps) {
  const { phoneNumber, supplierId, numberOfWorkers, experience } = props;
  const { t } = useTranslation('common');

  return (
    <div className='borde-xs flex justify-between gap-80 rounded-b-2xl border-neutralVariant-90 bg-background-neutral-99 p-20'>
      <div className='flex w-full gap-8'>
        <CallSvg width='21' height='21' />
        <div className='flex ' style={{ flexDirection: 'column' }}>
          <Typography variant='caption'>{t('phone-number')}</Typography>
          <Typography variant='body1'>{phoneNumber ?? '-'}</Typography>
        </div>
      </div>
      <div className='flex w-full gap-8'>
        <NoteSvg width='17' height='17' />
        <div className='flex ' style={{ flexDirection: 'column' }}>
          <Typography variant='caption'>{t('id-number')}</Typography>
          <Typography variant='body1'>{supplierId}</Typography>
        </div>
      </div>
      <div className='flex w-full gap-8'>
        <WorkerSvg width='24' height='24' />
        <div className='flex ' style={{ flexDirection: 'column' }}>
          <Typography variant='caption'>{t('workers-count')}</Typography>
          <Typography variant='body1'>{numberOfWorkers}</Typography>
        </div>
      </div>
      <div className='flex w-full gap-8'>
        <TreeSvg width='24' height='24' />
        <div className='flex ' style={{ flexDirection: 'column' }}>
          <Typography variant='caption'>{t('Experience')}</Typography>
          {experience && experience?.length > 0 ? (
            <PartialListWithTooltip
              limit={2}
              items={experience?.map((job) => {
                return {
                  description: job.jobName,
                  imageURL: job.cropImage,
                } as Item;
              })}
            />
          ) : (
            '-'
          )}
        </div>
      </div>
    </div>
  );
}
